import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, "Журнал содержит список планов.", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, " Наименование – описание плана погрузки в произвольной форме, по умолчанию созданному новому плану система присваивает очередной порядковый номер "),
  /*#__PURE__*/_createElementVNode("li", null, " Тип – состояние бывает нескольких типов: план - не рассчитан, в очереди на расчёт, рассчитывается, отменён или решение найдено "),
  /*#__PURE__*/_createElementVNode("li", null, "Дата расчёта – дата и время последнего расчёта"),
  /*#__PURE__*/_createElementVNode("li", null, "Дата создания – дата создания плана"),
  /*#__PURE__*/_createElementVNode("li", null, "Пользователь – пользователь последний рассчитавший"),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("div", null, "Действия:"),
    /*#__PURE__*/_createElementVNode("ul", null, [
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("i", { class: "dx-icon-edit" }),
        /*#__PURE__*/_createTextVNode(" – корректировка плана")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("i", { class: "dx-icon-trash" }),
        /*#__PURE__*/_createTextVNode(" – удаление плана, при нажатии система запросит подтверждение удаления плана ")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("i", { class: "dx-icon-copy" }),
        /*#__PURE__*/_createTextVNode(" – копирование плана")
      ])
    ])
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, " Для расчета плана необходимо добавить исходные данные с используемыми грузами и транспортами. ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, "Для запуска расчета нужно нажать кнопку «Рассчитать».", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, "После расчета станет активной вкладка «Результат».", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfoDialog = _resolveComponent("InfoDialog")!

  return (_openBlock(), _createBlock(_component_InfoDialog, {
    title: "Справка: Планы",
    ref: "dialog"
  }, {
    infoForm: _withCtx(({}) => [
      _hoisted_1,
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _hoisted_5
    ]),
    _: 1
  }, 512))
}